<template>
  <div style="height: 100%">
    <!-- <keep-alive > -->
    <router-view v-if="this.$route.path != '/StudentWork'" />
    <!-- </keep-alive> -->

    <div id="studentwork" class="studentwork" v-else>
      <div class="role-header">
        <img
          class="role-manage-logo headers"
          src="../../assets/imgs/zuoye.png"
        />
        <p class="role-manage-name">{{ $t('translateText.sw.zy') }}</p>
      </div>
      <div class="nav-header">
        <li>
          <p>{{ $t('translateText.sw.xzkc') }}：</p>
          <a-select
            :size="size"
            :default-value="$t('translateText.sw.qb')"
            style="width: 180px"
            @select="OnSelect"
          >
            <a-select-option
              v-for="item in course"
              :key="item.course.iCourseId"
            >
              {{ item.course.strCourseName }}
            </a-select-option>
          </a-select>
          <p style="margin-left: 30px">{{ $t('translateText.sw.zt') }}：</p>
          <a-select
            :size="size"
            :default-value="$t('translateText.sw.qb')"
            style="width: 150px; margin-left: 5px"
            @change="handleChange"
          >
            <a-select-option v-for="item in workstate" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </li>
        <li style="width: 20%">
          <search
            :placeholder="$t('translateText.sw.zymc')"
            @search="onSearch"
          />
        </li>
      </div>
      <div class="roleTable" ref="body">
        <publictable
          :columns="homework"
          :data2="homeworks"
          v-on:workinfo="workinformation"
          :show="false"
        ></publictable>
      </div>
      <pag ref="pag" @passpage="passpage" />
    </div>
  </div>
</template>

<script>
const moment = require('moment')
import search from '@/components/search'
import pag from '@/components/pagiation'
import publictable from '@/components/Table/Table'
import { getUserCourse, getPageExaminationReceiveByUser } from '../../utils/api'
export default {
  name: 'StudentWork',
  data() {
    return {
      //allAlign: null,
      // saveInfo: [],
      showTotal: null,
      pageNumber: 1,
      examinationState: 0,
      iCourseId: 0,
      examinationname: '',
      showstudentname: [],
      size: 'default',
      showuser: [],
      searchKey: '',
      pagShow: true,
      bodyHeight: 0,

      homeworks: [],
      course: [],
    }
  },
  components: {
    pag,
    publictable,
    search,
  },
  computed: {
    homework() {
      return [
        {
          title: this.$t('translateText.sw.zym'),
          dataIndex: 'examinationRelease.examination.strExaminationName',
        },
        {
          title: this.$t('translateText.sw.zysj'),
          dataIndex: 'time',
        },
        {
          title: this.$t('translateText.sw.cj'),
          dataIndex: 'iScore',
        },
        {
          title: this.$t('translateText.sw.cz'),
          dataIndex: 'ddExaminationState.iNumber',
          scopedSlots: { customRender: 'studystatus' },
        },
      ]
    },
    workstate() {
      return [
        {
          id: 0,
          name: this.$t('translateText.sw.qb'),
        },
        {
          id: 2,
          name: this.$t('translateText.sw.wtj'),
        },
        {
          id: 3,
          name: this.$t('translateText.sw.wpy'),
        },
        {
          id: 4,
          name: this.$t('translateText.sw.ypy'),
        },
      ]
    },
    selectedRowKey() {
      return this.selectedRowKeys.length > 0
    },
    search() {
      return this.searchKey.length
    },
  },
  mounted() {
    // this.bodyHeight = this.$refs.body.offsetHeight - 60;
    this.userinfo = this.$store.state.userinfo
    // if(this.$route.path == '/StudentWork'){
    this.getcourse()
    this.getPageExaminationReceive()
    // }
  },
  methods: {
    getdata() {
      this.getPageExaminationReceive()
    },
    passpage(pageNumber) {
      this.pageNumber = pageNumber
      // this.$refs.table.selectedRowKeys = this.selectedRowKeys
      this.getPageExaminationReceive()
    },
    //查询用户所有作业
    getPageExaminationReceive() {
      getPageExaminationReceiveByUser({
        iUserId: this.userinfo.iUserId,
        iExaminationState: this.examinationState,
        iCourseId: this.iCourseId,
        iExaminationType: 1,
        strExaminationName: this.examinationname,
        iCurPage: this.pageNumber,
        iPageSize: 10,
      }).then((response) => {
        if (response.data.iCode == 0) {
          this.homeworks = response.data.objData.listPage
          if (this.$refs.pag) {
            this.$nextTick(() => {
              this.$refs.pag.showTotal = response.data.objData.iTotalPages * 10
              this.$refs.pag.pageNumber = response.data.objData.iPageIndex
            })
          }
          sessionStorage.setItem(
            'showTotal',
            response.data.objData.iTotalPages * 10
          )
          sessionStorage.setItem('pageNumber', response.data.objData.iPageIndex)
          this.homeworks.map((item) => {
            let time =
              moment(item.examinationRelease.dtStartTime).format(
                'YYYY-MM-DD HH:mm'
              ) +
              this.$t('translateText.course.to') +
              moment(item.examinationRelease.dtEndTime).format(
                'YYYY-MM-DD HH:mm'
              )
            this.$set(item, 'time', time)
            this.$set(item, 'key', item.iExamReceiveId)
            if (
              item.ddExaminationState.iNumber != 5 ||
              item.examinationRelease.ddIsViewScore.iNumber == 0
            ) {
              item.iScore = this.$t('translateText.sw.zwfb')
            }
          })
        }
      })
    },
    getcourse() {
      getUserCourse({
        iUserId: this.userinfo.iUserId,
        timequantum: true,
        iRoleId: this.userinfo.role.iRoleId,
      }).then((response) => {
        if (response.data.iCode == 0) {
          this.course = response.data.objData
          this.course.unshift({
            course: {
              iCourseId: 0,
              strCourseName: this.$t('translateText.sw.qb'),
            },
          })
        }
      })
    },
    handleChange(value) {
      this.pageNumber = 1
      this.examinationState = value
      this.getPageExaminationReceive()
    },

    //通过课程筛选
    OnSelect(val) {
      //搜索按钮的回调事件
      this.iCourseId = val
      this.getPageExaminationReceive()
    },
    selectuser(val) {
      this.searchKey = val
      var that = this
      that.course.forEach((itemm) => {
        if (itemm.id != 1 && itemm.id == val) {
          that.showstudentname = []
          that.homeworks.forEach((item) => {
            if (item.course == itemm.name) {
              that.showstudentname.push(item)
            }
          })
        } else if (itemm.id == 1) {
          that.showstudentname = that.homeworks
        }
      })
      if (that.showstudentname.length != '0') {
        that.homeworks = []
        that.homeworks = this.showstudentname
        return that.$message.success(this.$t('translateText.cxwc'))
      } else {
        return that.$message.error(this.$t('translateText.wxc'))
      }
    },
    //通过作业状态筛选
    OnSelects(val) {
      //搜索按钮的回调事件
      this.selectwork(val)
    },
    selectwork(val) {
      this.searchKey = val
      var that = this
      that.workstate.forEach((itemm) => {
        if (itemm.id == val) {
          that.showstudentname = []
          if (itemm.name == this.$t('translateText.sw.ywc')) {
            that.homeworks.forEach((item) => {
              if (item.studystatus == 1) {
                that.showstudentname.push(item)
              }
            })
          } else if (itemm.name == this.$t('translateText.sw.wwc')) {
            that.homeworks.forEach((item) => {
              if (item.studystatus == 0) {
                that.showstudentname.push(item)
              }
            })
          }
        }
      })
      if (that.showstudentname.length != '0') {
        that.homeworks = []
        that.homeworks = this.showstudentname
        return that.$message.success(this.$t('translateText.cxwc'))
      } else {
        return that.$message.error(this.$t('translateText.wxc'))
      }
    },
    //搜索角色
    onSearch(val) {
      //搜索按钮的回调事件
      this.pageNumber = 1
      this.examinationname = val
      this.getPageExaminationReceive()
    },
    //打开作业详情页
    workinformation(row) {
      let Startime = Date.parse(
        moment(row.examinationRelease.dtStartTime).format('YYYY-MM-DD HH:mm:ss')
      )
      let nowtime = new Date().getTime()
      if (Startime > nowtime) {
        return this.$message.error(this.$t('translateText.sw.wdsj'))
      } else {
        this.$store.commit('getExamReceiveinfo', row)
        this.$router.push({
          path: '/StudentWork/StudentWorkInfo',
          query: {
            examtype: 1,
          },
        })
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
input
    outline: none
.header
    display: inline-block
    text-align: left
    margin-top: 18px
/deep/.ant-table-body .ant-table-tbody .ant-table-row .study
    color: #2EADB5
/deep/.ant-table-body .ant-table-tbody .ant-table-row .unstudy
    color: #2EADB5
.body-header
    display: inline-block
    text-align: left
    margin-top: 0
.on
    background: rgba(230, 245, 246, 0.5)
.off
    background: #FFFFFF
    border-radius: 5px
.updateroles
    visibility: hidden
.disupdateroles
    visibility: visible
.cursorpoint
    cursor: pointer
.studentwork
    height: 100%
    width: 100%
    position: relative
    background-color: #FFFFFF
    border-radius: 5px
    margin-top: 0px
    .role-header
        right: 2%
        left: 2%
        height: 8%
        font-size: 17px
        letter-spacing: 2px
        font-weight: 700
        display: -webkit-flex
        display: flex
        align-items: center
        position: absolute
        top: 1.3%
        border-bottom: 1px solid #D5D5D5
    .roleTable
        position: absolute
        top: 19%
        right: 2%
        left: 2%
        // bottom: 10%
        bottom:48px;
        overflow: auto;
    .roleTable::-webkit-scrollbar {
        display: none;
        }
    .role-manage-logo
        height: 20px
    .role-manage-name
        font-size: 2.22222222222vh
        font-weight: 700
        margin-left: 2.5%
    .nav-header
        right: 2%
        left: 2%
        height: 8%
        display: flex
        justify-content: space-between
        align-items: center
        position: absolute
        top: 10%
        li
            display: inline-block
            p
                display: inline-block
.headers
    display: inline-block
    position: absolute
.role-table
    display: block
    margin-top: 2.1%
    margin-left: 2%
    width: 94.17%
    height: 62%
.bodys
    margin-top: 4px
/deep/.ant-modal-content
    display: inline-block
    width: 500px
    height: 450px
    margin-left: 8%
    margin-top: 4%
/deep/.ant-modal-footer
    border-top: none
    margin-top: 340px
/deep/.ant-btn-primary
    background: #2EADB5
    margin-right: 26%
    margin-left: 18%
.edit-roles
    position: absolute
    width: 100%
    height: 100%
    top: 0
    left: 50%
    transform: translateX(-50%)
    .edit-title
        diaplay: inline-block
        position: absolute
        top: 0
        left: 50%
        transform: translateX(-50%)
        font-family: Source Han Sans CN
        font-weight: bold
        color: #4E4E4E
        margin-top: 4%
        font-size: 2.05185185185vh
    img
        width: 12px
        height: 12px
        top: 5.8%
        right: 6%
    .setting-role
        top: 9.02%
    .public-setting
        left: 6%
        font-size: 1.57407407407vh
        font-family: Source Han Sans CN
        font-weight: bold
        color: #2EADB5
        line-height: 41px
        @media screen and (max-height: 1100px) and (max-width: 900px)
            font-size: 1.166666666vh
        @media screen and (min-height: 1200px) and (min-width: 1000px)
            font-size: 1.166666666vh
    .setting-privileges
        top: 42.12%
    .left-setrole
        top: 12.42%
        @media screen and (max-height: 1100px) and (max-width: 900px)
            top: 11.8%
        @media screen and (min-height: 1200px) and (min-width: 1000px)
            top: 11.8%
    .public-left
        width: 4px
        height: 10px
        position: absolute
        left: 4%
        background: #2EADB5
    .left-privileges
        top: 45.52%
        @media screen and (max-height: 1100px) and (max-width: 900px)
            top: 44.8%
        @media screen and (min-height: 1200px) and (min-width: 1000px)
            top: 44.8%
    .role-inform
        position: absolute
        left: 50%
        transform: translateX(-50%)
        top: 18.02%
        width: 93%
        height: 23.345%
        border: 1px solid #D5D5D5
        .role-inform-left
            width: 16.34%
            height: 100%
            margin-left: 0
            background: #F5F5F5
            font-size: 1.6666666666vh
            @media screen and (max-height: 1100px) and (max-width: 900px)
                font-size: 1.0666666666vh
            @media screen and (min-height: 1200px) and (min-width: 1000px)
                font-size: 1.0666666666vh
            .edit-role-name
                top: 14%
                left: 3%
            .edit-role-note
                top: 66%
                left: 3%
        .line-center
            position: absolute
            top: 50%
            transform: translateY(-50%)
            width: 100%
            height: 1px
            background: #D5D5D5
        .role-inform-right
            width: 83.66%
            height: 100%
        .role-identify
            top: 10%
            height: 30%
            left: 20%
            border: 1px solid #D5D5D5
        .role-noteinfor
            width: 76%
            height: 35%
            top: 59%
            left: 20%
            border: 1px solid #D5D5D5
    .select-privileges
        position: absolute
        bottom: 15%
        left: 50%
        transform: translateX(-50%)
        width: 93%
        height: 34.32%
        border: 1px solid #D5D5D5
        padding-left: 2%
        padding-top: 1%
        text-align: left
    .setting-button
        position: absolute
        bottom: 5%
        width: 60px
        height: 28px
        line-height: 28px
        font-size: 1.6666666666vh
        border-radius: 4px
    .setting-concel
        left: 34%
        color: #2eadb5
        border: 1px #2eadb5 solid
    .setting-sure
        right: 34%
        background-color: #2eadb5
        border: #2eadb5
        color: #FFFFFF
.roles-select
    top: 50%
    transform: translateY(-50%)
    left: 34%
.select-all
    left: 3.9%
    top: 24%
    background: red
    z-index: 999
</style>
